// extracted by mini-css-extract-plugin
module.exports = {"error_page":"errorPage_error_page__Ig3Kh","error_container":"errorPage_error_container__5D8iK","d_flex":"errorPage_d_flex__QKOjm","info_section":"errorPage_info_section__vlkC5"};